import { config } from '../../../utils/config';

const AddressLegend = ({
  addressValues: { country, firstName, lastName, street, houseNumber, streetHouseNumber, additional, zipCode, city },
}: {
  addressValues: any;
}) => {
  const addressConfig = config.addressForm[country];

  const formattedStreetHouseNumber = addressConfig.streetHouseNumber.separateFields
    ? addressConfig.streetHouseNumber.houseNumber.position === 'second'
      ? `${street} ${houseNumber}`
      : `${houseNumber} ${street}`
    : streetHouseNumber;

  const formattedZipCodeCity =
    addressConfig.zipCodeCity.zipCode.position === 'first' ? `${zipCode} ${city}` : `${city} ${zipCode}`;

  return (
    <p className="billing-address-form__legend">
      {[firstName + ' ' + lastName, formattedStreetHouseNumber, additional, formattedZipCodeCity]
        .filter(Boolean)
        .join(' · ')}
    </p>
  );
};

export default AddressLegend;
